module.exports = __webpack_public_path__ + "img/assignment.483914e7.svg";